import { render, staticRenderFns } from "./AppliedSearchFacets.vue?vue&type=template&id=5c47d1aa&scoped=true&"
import script from "./AppliedSearchFacets.vue?vue&type=script&lang=ts&"
export * from "./AppliedSearchFacets.vue?vue&type=script&lang=ts&"
import style0 from "./AppliedSearchFacets.vue?vue&type=style&index=0&id=5c47d1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c47d1aa",
  null
  
)

export default component.exports